module.exports = __webpack_public_path__ + "img/BI.e0a27877.png";